import React, { Component }          from 'react';
import Select                        from 'react-select'
import { ROLES }                     from '../../common/Common';

import icClose                       from '../../../img/ic_close.svg';

import "./Dialog.scss";

class ExportRecordingsDialog extends Component {

  constructor(props) {
    super(props);

    this.state            = {

    }
  }

  renderDownloadLink() {
    if (this.props.exportUrl) {
      return <a href={this.props.exportUrl}>Download Link</a>
    } else {
      return <div>...</div>
    }
  }

  render() {
    return (
      <div className={`edit-dialog ${this.props.show ? 'show' : ''}`}>
        <div className="content search">
          <div className="dialog-title h2">{this.props.exportInProgress ? "Export in progress (up to 10 minutes)..." : this.props.title}</div>
          <div className="dialog-subtitle">[Max 500 recordings]</div>
          <div className="links">
            {this.renderDownloadLink()}
          </div>
          <div className="bottom-buttons">
            <div onClick={this.props.export.bind(this)} className={`action-button`}>EXPORT</div>
          </div>
          <img onClick={this.props.closeDialog.bind(this)} className="close" src={icClose}/>
        </div>
      </div>
    );
  }
}

export default ExportRecordingsDialog;